import { present } from "../../../utils/presenter";
import { Repository } from "../../adapters/repository";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ name, template, folder, namespace, type }) =>
    present(
      repository
        .createDocument(name, template, folder.uuid, namespace, type)
        .then((document) => ({
          name,
          template,
          namespace,
          type,
          document,
          folder,
        }))
        .catch(() =>
          Promise.reject({ name, template, namespace, type, folder }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
